import classNames from 'classnames'
import * as React from 'react'
const styles = require('./styles')

interface QuestionToggleProps {
  children: JSX.Element | JSX.Element[]
  question: string
}
export const QuestionAccordion: React.FC<QuestionToggleProps> = ({ question, children }: QuestionToggleProps) => {
  const [isCollapsed, setCollapsed] = React.useState(true)
  return (
    <div onClick={() => setCollapsed(!isCollapsed)} className={styles.faqQuestionAccordion}>
      <div>
        <div className={classNames(styles.toggleIcon, isCollapsed ? styles.plus : styles.minus)}></div>
        <span data-testid="li-faq-question" className={styles.faqQuestion}>
          {question}
        </span>
      </div>
      <div
        data-testid="li-faq-answer"
        className={classNames([styles.faqAnswer, isCollapsed ? styles.collapsed : styles.expanded])}
      >
        {children}
      </div>
    </div>
  )
}

export const FAQs: React.FC = () => (
  <div className={styles.liFaqWrapper}>
    <p data-testid="li-faq-header" className={styles.faqHeader}>
      Frequently Asked Questions
    </p>
    <QuestionAccordion question={'What do Term and Coverage mean?'}>
      <p>
        Term is the amount of time you want to hold the policy for. Common term lengths for level-term policies are 10,
        15, 20, and 30 years. You can extend your coverage beyond the initial set term length at a higher premium
        without having to reprove your health. Your beneficiaries don't receive any benefit if you outlive the term
        policy. Coverage is the tax-free lump sum (also called death benefit) your beneficiaries would receive if you
        pass away during your life insurance policy's valid term.
      </p>
    </QuestionAccordion>
    <QuestionAccordion question={'What does life insurance cover?'}>
      <p>
        If illness or injury strikes and you or your family are in desperate need of immediate cash, life insurance can
        provide the funds. Although it’s an unpleasant thought, should death occur during your working years, life
        insurance helps cover mortgage or rent payments, utilities, credit card bills, and other debts owed.
      </p>
      <p>
        Life insurance can also be used to pay funeral costs, unpaid medical bills, college tuition, taxes, and/or
        everyday living expenses. In other words, life insurance proceeds can be used by your beneficiaries in any
        variation of ways depending on what they require.
      </p>
    </QuestionAccordion>

    <QuestionAccordion question={'What kind of life insurance policy quotes do you provide?'}>
      <p>We provide quotes for term life, guaranteed issue final expense, and accidental death benefits.</p>
      <p>
        Term policies that cover you in the event of a death from both natural or accidental causes, anywhere you go in
        the world. The only reason the policy would not pay out would be if there were a suicide in the first two years
        of the policy.
      </p>
      <p>
        Guaranteed Issue Final Expense policies are permanent policies that cover you to age 100 and your acceptance is
        guaranteed, no health questions are asked. These policies are for smaller amounts of coverage meant to help with
        final expenses.
      </p>
      <p>
        ADB policies cover you in the event of a death from accidental causes only and you can keep the policy to age
        80.
      </p>
      <p>
        There are no hidden exclusions in any of the policies we sell because we believe in being transparent so you can
        live on your terms and leave on your terms.
      </p>
    </QuestionAccordion>
    <QuestionAccordion question={'When is the best time to get life insurance?'}>
      <p>
        The decision to buy your first life insurance policy can be tricky. Is it really time to buy coverage and, if
        so, for whom should it provide financial benefits?
      </p>
      <p>
        There are many times in your life where life insurance should be a consideration. Whether you have a spouse or
        family, bought a home, or want to leave a lasting legacy for others, a life insurance policy can help you get
        there. In the end, life insurance is for the living. Who do you want to take care of after you’re gone?
      </p>
      <p>
        Want to learn more about your life insurance options or get a free quote? Contact us today – our licensed life
        insurance coaches can walk you through the policies available and even help you calculate the coverage that best
        suits your needs.
      </p>
    </QuestionAccordion>
    <QuestionAccordion question={'What is "no exam" life insurance?'}>
      <p>
        Most traditional life insurance plans require a medical exam, blood work, or both. Getting a “no exam” life
        insurance plan is just as the name implies – no needles or doctor visits required. Answer a few basic
        health-related questions over the phone or online and you’re good to go. No exam plans may not be available to
        every individual or for every policy.
      </p>
    </QuestionAccordion>
  </div>
)
